import {
  UseMutateAsyncFunction,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { UserProfileDto, UserRole } from "@green0meter/api-client";

import { DOMAIN_FILE_STORAGE } from "../domain";

import {
  ACTION_GET_PROCUREMENT_SUPPLIERS_REPORTS_METADATA,
  DOMAIN_PROCUREMENT,
  roleGuard,
} from "@api";
import { fileStorageApi } from "@api/services";

export const ACTION_DOWNLOAD_FILE = "DOWNLOAD_FILE";

const allowedRoles = [UserRole.Owner, UserRole.Manager, UserRole.Respondent];

const deleteUserFileAsync = async (filePath: string): Promise<void> => {
  const response =
    await fileStorageApi.abstractFileStorageControllerDeleteUserFile(filePath);

  return response.data;
};

export const useDeleteUserFile = (
  user: UserProfileDto | null,
): {
  deleteUserFileAsync: UseMutateAsyncFunction<void, Error, string, unknown>;
  deleteUserFileEnabled: boolean;
  isSuccessDeleteFile: boolean;
  isPendingDeleteFile: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const queryClient = useQueryClient();

  const { mutateAsync, isSuccess, isPending } = useMutation({
    mutationKey: [DOMAIN_FILE_STORAGE, ACTION_DOWNLOAD_FILE],
    mutationFn: enabled ? deleteUserFileAsync : undefined,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [
          DOMAIN_PROCUREMENT,
          ACTION_GET_PROCUREMENT_SUPPLIERS_REPORTS_METADATA,
        ],
      });
    },
  });

  return {
    deleteUserFileAsync: mutateAsync,
    deleteUserFileEnabled: enabled,
    isSuccessDeleteFile: isSuccess,
    isPendingDeleteFile: isPending,
  };
};
